export const PRODUCT_STATUS_DRAFT = "draft"
export const PRODUCT_STATUS_PUBLISHED = "published"
export const PRODUCT_STATUS_ARCHIVED = "archived"

export const SELECTABLE_PRODUCT_STATUSES = [
    PRODUCT_STATUS_DRAFT,
    PRODUCT_STATUS_PUBLISHED,
    PRODUCT_STATUS_ARCHIVED,
]
